import { render, staticRenderFns } from "./campDetailsData.vue?vue&type=template&id=d529149a&scoped=true&"
import script from "./campDetailsData.vue?vue&type=script&lang=js&"
export * from "./campDetailsData.vue?vue&type=script&lang=js&"
import style0 from "./campDetailsData.vue?vue&type=style&index=0&id=d529149a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d529149a",
  null
  
)

export default component.exports